export const DepositStatus = {
  Pending: "Pending",
  InProgress: "InProgress",
};
